import { createDCHook, collapseDataFromCall } from '../client';
import { getAddressPublic, getAddressBusinessCheck } from '../services/AddressPublicService';

export const useAddressPublicGetAddressPublic = createDCHook(
  'getAddressPublic',
  collapseDataFromCall(getAddressPublic),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);

export const useAddressPublicGetAddressBusinessCheck = createDCHook(
  'getAddressBusinessCheck',
  collapseDataFromCall(getAddressBusinessCheck),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);
